import React from "react";
// Components
import VerifyToken from "../../config/verifyToken";
import { Main } from "../generalStyle";
import Header from "../../components/header";
import Patients from "../../components/patients";
import Footer from "../../components/footer";
import StickyLogo from "../../components/stickyLogo";

const Home = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <Patients />
    </Main>
    <Footer />
  </>
);

export default Home;
